import React, { useEffect, useRef } from 'react';
import { MonetizedContentWithCards } from '@adimpress/imprezia-sdk';
import './AdBanner.css';

class ImpreziaErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[Imprezia] ❌ Render error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Silently fail - don't show error to users
      console.error('[Imprezia] Ad rendering failed, hiding ad');
      return null;
    }
    return this.props.children;
  }
}

const ImpreziaAdBanner = ({ monetizedResult, messageId }) => {
  console.log('[ImpreziaAdBanner] Rendering for message:', messageId);
  console.log('[ImpreziaAdBanner] monetizedResult:', monetizedResult);
  
  if (!monetizedResult) {
    console.log('[ImpreziaAdBanner] No monetizedResult, returning null');
    return null;
  }

  // Check if there are actually ads in the result (linkData object with keys)
  const hasAds = monetizedResult && monetizedResult.linkData && Object.keys(monetizedResult.linkData).length > 0;
  console.log('[ImpreziaAdBanner] Has ads:', hasAds);
  console.log('[ImpreziaAdBanner] linkData:', monetizedResult.linkData);
  
  if (!hasAds) {
    console.log('[ImpreziaAdBanner] ⚠️ Imprezia returned no ads for this message');
    return null;
  }

  const adCount = Object.keys(monetizedResult.linkData).length;
  console.log('[ImpreziaAdBanner] Rendering Imprezia ad with', adCount, 'ad(s)');

  return (
    <div 
      className="ad-banner imprezia-ad-banner" 
      style={{ minHeight: 110 }}
      data-message-id={messageId}
    >
      <ImpreziaErrorBoundary>
        <MonetizedContentWithCards
          response={monetizedResult}
          theme="light"
          hideResponseContainer={true}
          onCardClick={(trackingId) => console.log('Imprezia card clicked:', trackingId)}
          onLinkClick={(trackingId) => console.log('Imprezia link clicked:', trackingId)}
        />
      </ImpreziaErrorBoundary>
    </div>
  );
};

export default ImpreziaAdBanner;
